import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { fetchProjects } from "../lib/api";
import "./ProjectsPage.css";
import Projects_BG from "../components/ui/Projects.png";

import VirtualStudio from "../components/ui/vssBig.svg";
import VirtualProductions from "../components/ui/VirtualProductions.svg";
import IntelliTrack from "../components/ui/IntelliTrack.svg";
import ImmersiveExp from "../components/ui/ImmersiveExp.svg";
import IntExh from "../components/ui/Intexmu.svg";
import DefenceImg from "../components/ui/new.svg";
import DroneImg from "../components/ui/dronesmall.svg";

const LOCAL_IMAGES = {
    "virtualstudio.svg": VirtualStudio,
    "VirtualProductions.svg": VirtualProductions,
    "IntelliTrack.svg": IntelliTrack,
    "ImmersiveExp.svg": ImmersiveExp,
    "IntExh.svg": IntExh,
    "defence.svg": DefenceImg,
    "drone.svg": DroneImg,
    "Defence.svg": DefenceImg,
    "Drone.svg": DroneImg,
};

const getImageUrl = (p) => {
    const title = (p.title || "").toLowerCase();
    if (title.includes("tactical") || title.includes("combat")) return DefenceImg;
    if (title.includes("drone")) return DroneImg;
    return LOCAL_IMAGES[p.image_url] || p.image_url;
};

const CATEGORIES = ["All", "Defence", "Immersive", "Virtual Production", "Interactive", "Innovation"];


export default function ProjectsPage() {

    const [projects, setProjects] = useState([]);
    const [active, setActive] = useState("All");
    const [loading, setLoading] = useState(true);
    const [expandedIds, setExpandedIds] = useState({});

    const toggleExpand = (id, e) => {
        e.stopPropagation();
        setExpandedIds(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    useEffect(() => {
        setLoading(true);
        fetchProjects(active)
            .then(setProjects)
            .catch((e) => console.error(e))
            .finally(() => setLoading(false));
    }, [active]);

    return (
        <main data-testid="projects-page" className="projects-page-wrapper">
            {/* Hero */}
            <section className="projects-hero border-bottom position-relative overflow-hidden">
                <div
                    className="hero-bg-image"
                    style={{ backgroundImage: `url(${Projects_BG})` }}
                    aria-hidden
                />
                <div
                    className="hero-overlay"
                    aria-hidden
                />
                <div className="grain position-absolute top-0 bottom-0 start-0 end-0 pe-none" aria-hidden />

                <div className="container-db position-relative">
                    <div className="font-mono-tech section-eyebrow fade-in-up fs-5">
                        ⟶ Our work
                    </div>
                    <h1
                        data-testid="projects-page-title"
                        className="font-heading hero-title mb-0"
                    >
                        Featured
                        <br />
                        <span className="text-primary-custom">Works</span>
                    </h1>
                    <p className="projects-hero-desc mt-4 mb-0" style={{ fontSize: "20px" }}>
                        Explore a portfolio of landmark projects spanning defence, immersive technologies, virtual production, interactive museums, and large-scale experiential installations - designed, engineered, and delivered in-house.
                    </p>
                </div>
            </section>

            {/* Filters */}
            <section className="sticky-filters border-bottom py-4">
                <div className="container-db d-flex flex-wrap gap-2">
                    {CATEGORIES.map((c) => (
                        <button
                            key={c} style={{ fontSize: "15px", color: "#f1eaeaff" }}
                            onClick={() => setActive(c)}
                            data-testid={`projects-filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
                            className={`interest-btn  font-mono-tech ${active === c ? "active" : ""
                                }`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
            </section>

            {/* Grid */}
            <section className="py-5 py-md-10">
                <div className="container-db">
                    {loading ? (
                        <div className="row g-3">
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="col-12 col-md-6 col-lg-4">
                                    <div className="project-pulse-card" />
                                </div>
                            ))}
                        </div>
                    ) : projects.length === 0 ? (
                        <div
                            data-testid="projects-empty"
                            className="text-center py-5 text-muted-custom font-mono-tech text-xs uppercase tracking-[0.2em]"
                        >
                            No projects in this category yet.
                        </div>
                    ) : (
                        <div className="row g-3">
                            {projects.map((p) => (
                                <div key={p.id} className="col-12 col-md-6 col-lg-4">
                                    <article
                                        data-testid={`project-tile-${p.id}`}
                                        className="position-relative overflow-hidden group-hover-parent project-card bg-dark"
                                    >
                                        <div
                                            className="project-card-img bg-cover bg-center"
                                            style={{ backgroundImage: `url(${getImageUrl(p)})` }}
                                        />
                                        <div className="project-card-overlay" />
                                        <div className="position-relative h-100 p-3 d-flex flex-column justify-content-between project-card-content">
                                            <div className="d-flex align-items-center justify-content-between">
                                                {/* <span className="font-mono-tech defence-label-top fs-5 fw-bold">
                                                    {p.category}
                                                </span>
                                                 
                                                <ArrowUpRight size={20} className="text-white card-arrow" /> */}
                                                <div className="font-mono-tech defence-label-top fw-bold" style={{ fontSize: '15px' }}>
                                                    {p.title}
                                                </div>
                                            </div>
                                            <div>

                                                <p
                                                    className={`project-card-desc mb-3 max-w-xl ${expandedIds[p.id] ? "is-expanded" : ""}`}
                                                    onClick={(e) => toggleExpand(p.id, e)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {p.description}
                                                </p>

                                            </div>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </main>
    );
}
